import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { PlatformNotSupportedError } from '../errors/PlatformNotSupportedError.mjs';
import '../errors/errorHelpers.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * @internal
 */

var KeyValueStorage = /*#__PURE__*/function () {
  function KeyValueStorage(storage) {
    _classCallCheck(this, KeyValueStorage);

    this.storage = storage;
  }
  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */


  _createClass(KeyValueStorage, [{
    key: "setItem",
    value: function () {
      var _setItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.storage) {
                  _context.next = 2;
                  break;
                }

                throw new PlatformNotSupportedError();

              case 2:
                this.storage.setItem(key, value);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setItem(_x, _x2) {
        return _setItem.apply(this, arguments);
      }

      return setItem;
    }()
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */

  }, {
    key: "getItem",
    value: function () {
      var _getItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.storage) {
                  _context2.next = 2;
                  break;
                }

                throw new PlatformNotSupportedError();

              case 2:
                return _context2.abrupt("return", this.storage.getItem(key));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getItem(_x3) {
        return _getItem.apply(this, arguments);
      }

      return getItem;
    }()
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */

  }, {
    key: "removeItem",
    value: function () {
      var _removeItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.storage) {
                  _context3.next = 2;
                  break;
                }

                throw new PlatformNotSupportedError();

              case 2:
                this.storage.removeItem(key);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeItem(_x4) {
        return _removeItem.apply(this, arguments);
      }

      return removeItem;
    }()
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */

  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.storage) {
                  _context4.next = 2;
                  break;
                }

                throw new PlatformNotSupportedError();

              case 2:
                this.storage.clear();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function clear() {
        return _clear.apply(this, arguments);
      }

      return clear;
    }()
  }]);

  return KeyValueStorage;
}();

export { KeyValueStorage };